export class UserName {
  id: string;
  uid: string;
}
